import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AblyMessageData } from '@models/ably';
import { TranslateService } from '@ngx-translate/core';
import { Certification } from '@queries/generated';
import { AblyChannel, AblyChannelsService } from '@services/ably-channels.service';
import { VerifiedCredentialsService } from '@services/verified-credentials.service';
import { Message } from 'primeng/api';

@Component({
  selector: 'vnm-verified-credential',
  templateUrl: './verified-credential.component.html',
  styleUrls: ['./verified-credential.component.scss']
})
export class VerifiedCredentialComponent implements OnInit {
  @Input() certification: Certification;

  @Output() canDeactivate = new EventEmitter<boolean>();

  appUrl: string;
  codeUrl: string;
  channel: AblyChannel = null;
  message: Message = {
    summary: this.translateService.instant(`verified-credential.message.preparing-credential`),
    severity: 'warn'
  };

  constructor(
    private verifiedCredentialsService: VerifiedCredentialsService,
    private ablyChannels: AblyChannelsService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.canDeactivate.emit(false);

    this.getQRCode();
  }

  // Componentize this when we can differentiate ms, credivera etc
  private getQRCode() {
    const input = { certificationId: this.certification.gid };
    this.verifiedCredentialsService.issue(input).subscribe(
      ({ url, appUrl, channelData }) => {
        this.appUrl = appUrl;
        this.codeUrl = url;
        this.channel = this.ablyChannels.get(channelData);
        if (url) {
          this.message = null;
        }
      },
      (error) => {
        this.message = {
          severity: 'error',
          summary: error.message
        };
      }
    );
  }

  onCredentialIssued(event: AblyMessageData) {
    this.message = {
      severity: 'success',
      summary: this.translateService.instant(`verified-credential.message.${event.content.message}`)
    };
    this.canDeactivate.emit(true);
  }

  onCredentialError(event: AblyMessageData) {
    this.message = {
      severity: 'error',
      summary: this.translateService.instant(`verified-credential.message.${event.content.message}`)
    };
  }
}
